module.exports = __webpack_public_path__ + "vue-app/img/small-4.ab49325d.jpg";